var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 89,
    viewBox: "0 0 147 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5966 52.8215C92.4852 53.2069 82.4658 53.7395 73.6165 53.7395C64.7672 53.7395 54.7478 53.2069 48.6364 52.8215C48.2742 52.7986 48.2185 53.3312 48.5756 53.387C54.6617 54.333 64.6811 55.6391 73.6139 55.6391C82.5468 55.6391 92.5688 54.333 98.6523 53.387C99.0094 53.3312 98.9537 52.7986 98.5915 52.8215H98.5966Z",
    fill: "url(#paint0_linear_301_2739)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5536 57.6654C87.7642 57.8886 80.2649 58.1752 73.6165 58.1752C66.9681 58.1752 59.4713 57.8861 54.6794 57.6654C54.3173 57.6477 54.2666 58.1802 54.6237 58.2335C59.3953 58.9614 66.8998 59.9099 73.6165 59.9099C80.3333 59.9099 87.8352 58.9614 92.6093 58.2335C92.9664 58.1777 92.9157 57.6477 92.5536 57.6654Z",
    fill: "url(#paint1_linear_301_2739)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.94 42.1267V35.5328C108.94 18.8757 97.4291 4.91954 81.9467 1.16611C79.2772 0.519401 76.4836 0.182098 73.6191 0.182098C70.7546 0.182098 67.9585 0.519401 65.2865 1.16611C49.8015 4.91701 38.2954 18.8732 38.2954 35.5303V42.1242C33.4427 43.027 30.5884 44.1252 30.5884 45.3095C30.5884 48.3909 49.8547 50.889 73.6191 50.889C97.3835 50.889 116.65 48.3909 116.65 45.3095C116.65 44.1252 113.796 43.027 108.943 42.1242L108.94 42.1267ZM87.311 47.3257C78.0691 47.3257 78.0007 39.2736 78.0007 34.8506C78.0007 29.4437 69.2325 29.4437 69.2325 34.8506C69.2325 39.2736 69.1641 47.3257 59.9222 47.3257C54.3781 47.3257 42.6719 42.9383 42.9455 34.9876C43.219 27.0369 44.4524 22.6494 52.9395 19.9054C61.4292 17.1638 85.8065 17.1638 94.2936 19.9054C102.783 22.6469 104.014 27.0344 104.288 34.9876C104.561 42.9383 92.8551 47.3257 87.311 47.3257Z",
    fill: "url(#paint2_linear_301_2739)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9394 21.531C61.4291 18.7895 85.8064 18.7895 94.2935 21.531C102.783 24.2725 104.014 28.66 104.288 36.6132C104.561 44.5639 92.855 48.9514 87.3109 48.9514C78.069 48.9514 78.0006 40.8992 78.0006 36.4763C78.0006 31.0693 69.2324 31.0693 69.2324 36.4763C69.2324 40.8992 69.164 48.9514 59.9221 48.9514C54.378 48.9514 42.6719 44.5639 42.9454 36.6132C43.2189 28.6625 44.4523 24.2751 52.9394 21.531Z",
    fill: "#211C36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9394 19.8166C61.4291 17.0751 85.8064 17.0751 94.2935 19.8166C102.783 22.5581 104.014 26.9456 104.288 34.8988C104.561 42.852 92.855 47.237 87.3109 47.237C78.069 47.237 78.0006 39.1848 78.0006 34.7619C78.0006 29.3549 69.2324 29.3549 69.2324 34.7619C69.2324 39.1848 69.164 47.237 59.9221 47.237C54.378 47.237 42.6719 42.8495 42.9454 34.8988C43.2189 26.9481 44.4523 22.5607 52.9394 19.8166Z",
    fill: "url(#paint3_linear_301_2739)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.994 78.8033C15.994 85.0814 11.4456 88.3232 6.30997 88.3232H2.43265C1.01594 88.3232 0 87.3049 0 85.8848V71.9928C0 70.5728 1.01594 69.5545 2.43265 69.5545H6.30997C11.4456 69.5545 15.994 72.7962 15.994 78.8033ZM11.5761 78.8033C11.5761 74.8609 9.64671 73.254 6.30997 73.254H4.38063V84.6236H6.30997C9.65603 84.6236 11.5761 83.0167 11.5761 78.8033Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5972 71.0306C17.5972 69.8814 18.6131 68.9099 19.7688 68.9099C20.9246 68.9099 21.9405 69.8721 21.9405 71.0306C21.9405 72.189 20.9246 73.1232 19.7688 73.1232C18.6131 73.1232 17.5972 72.161 17.5972 71.0306ZM21.9126 76.4678V86.3053C21.9126 87.5104 20.9246 88.4727 19.7688 88.4727C18.6131 88.4727 17.6251 87.5104 17.6251 86.3053V76.4678C17.6251 75.2626 18.6131 74.3004 19.7688 74.3004C20.9246 74.3004 21.9126 75.2626 21.9126 76.4678Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7601 76.1969C36.7601 76.5986 36.6296 76.9442 36.4898 77.2152L32.0253 86.7349C31.5406 87.7533 30.8789 88.3699 29.8816 88.3699C28.8843 88.3699 28.2225 87.7533 27.7658 86.7349L23.2733 77.2152C23.1708 76.9442 23.031 76.5986 23.031 76.1969C23.031 75.1785 23.8605 74.291 24.979 74.291C25.7806 74.291 26.5542 74.7768 27.0109 75.8231L29.8723 82.4749L32.7616 75.8231C33.1904 74.7768 33.964 74.291 34.7655 74.291C35.912 74.291 36.7415 75.1785 36.7415 76.1969H36.7601Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6475 80.6812C50.6475 82.3721 49.7341 82.9326 48.0285 82.9326L41.2058 82.8486C41.5787 84.2126 42.6785 85.0254 44.4121 85.0254C45.2137 85.0254 45.3441 84.9133 46.0991 84.7264C46.6583 84.5396 47.115 84.2966 47.6556 84.2966C48.5411 84.2966 49.0723 84.9133 49.0723 85.7167C49.0723 86.2305 48.858 86.8471 48.0564 87.4637C47.143 88.0242 45.9127 88.454 44.235 88.454C40.6 88.454 36.7693 86.2772 36.7693 81.4006C36.7693 76.5239 40.861 74.2163 43.9088 74.2163C46.9566 74.2163 50.6475 76.6546 50.6475 80.6812ZM41.1965 80.0085H46.444C46.1737 78.4764 45.1298 77.9159 43.8995 77.9159C42.6692 77.9159 41.4389 78.4764 41.1965 80.0085Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4831 82.7458C66.4831 85.9876 64.125 88.3232 59.5766 88.3232H54.6834C53.2667 88.3232 52.2507 87.3049 52.2507 85.8848V71.9928C52.2507 70.5728 53.2667 69.5545 54.6834 69.5545H59.2318C62.3355 69.5545 65.113 71.0305 65.113 74.3004C65.113 75.7484 64.5538 77.1124 62.8109 77.8411C65.6443 78.9902 66.4738 80.7653 66.4738 82.7458H66.4831ZM56.6407 76.6546H59.2318C60.1638 76.6546 60.8349 75.8232 60.8349 74.8609C60.8349 73.7585 60.1638 73.254 59.2318 73.254H56.6407V76.664V76.6546ZM62.205 82.3441C62.205 81.2977 61.6924 80.0085 59.586 80.0085H56.6407V84.6236H59.586C61.6458 84.6236 62.205 83.3624 62.205 82.3441Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0957 81.8303V76.3837C68.0957 75.2066 69.0557 74.263 70.2394 74.263C71.4231 74.263 72.3552 75.1972 72.3552 76.3837V81.8303C72.3552 83.9229 73.3152 84.8571 74.7319 84.8571C76.9222 84.8571 77.4069 82.6337 77.4069 82.3348V76.3837C77.4069 75.2066 78.3948 74.263 79.5506 74.263C80.7063 74.263 81.6943 75.1972 81.6943 76.3837V86.2492C81.6943 87.4544 80.7063 88.4259 79.5506 88.4259C78.3948 88.4259 77.4069 87.4637 77.4069 86.2492V85.4177C77.323 86.408 75.8038 88.4727 73.0728 88.4727C70.3419 88.4727 68.0957 86.5388 68.0957 81.8209V81.8303Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5205 71.2922V86.3613C97.5205 87.5384 96.4766 88.482 95.3302 88.482C94.3422 88.482 93.4568 87.7813 93.2424 86.8191C92.8416 87.5197 91.6672 88.51 89.7099 88.51C86.7646 88.51 83.2881 86.2585 83.2881 81.3538C83.2881 76.4491 86.8206 74.2256 89.7099 74.2256C91.5274 74.2256 92.8416 75.2439 93.1865 76.1782V76.4211C93.1865 76.309 93.1865 76.2062 93.2144 76.1034V71.3015C93.2144 70.1524 94.1744 69.1808 95.3302 69.1808C96.4859 69.1808 97.5205 70.143 97.5205 71.3015V71.2922ZM93.3729 81.3538C93.3729 78.7286 91.6858 77.8691 90.5115 77.8691C88.9829 77.8691 87.5662 79.0743 87.5662 81.3538C87.5662 83.6333 88.9829 84.8665 90.5115 84.8665C91.6858 84.8665 93.3729 84.035 93.3729 81.3538Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.365 71.2922V86.3613C113.365 87.5384 112.321 88.482 111.175 88.482C110.187 88.482 109.302 87.7813 109.087 86.8191C108.686 87.5197 107.512 88.51 105.555 88.51C102.609 88.51 99.1328 86.2585 99.1328 81.3538C99.1328 76.4491 102.665 74.2256 105.555 74.2256C107.372 74.2256 108.686 75.2439 109.031 76.1782V76.4211C109.031 76.309 109.031 76.2062 109.059 76.1034V71.3015C109.059 70.1524 110.019 69.1808 111.175 69.1808C112.331 69.1808 113.365 70.143 113.365 71.3015V71.2922ZM109.218 81.3538C109.218 78.7286 107.531 77.8691 106.356 77.8691C104.828 77.8691 103.411 79.0743 103.411 81.3538C103.411 83.6333 104.828 84.8665 106.356 84.8665C107.531 84.8665 109.218 84.035 109.218 81.3538Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.509 71.0306C115.509 69.8814 116.525 68.9099 117.681 68.9099C118.836 68.9099 119.852 69.8721 119.852 71.0306C119.852 72.189 118.836 73.1232 117.681 73.1232C116.525 73.1232 115.509 72.161 115.509 71.0306ZM119.815 76.4678V86.3053C119.815 87.5104 118.827 88.4727 117.671 88.4727C116.516 88.4727 115.528 87.5104 115.528 86.3053V76.4678C115.528 75.2626 116.516 74.3004 117.671 74.3004C118.827 74.3004 119.815 75.2626 119.815 76.4678Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.334 80.6812C135.334 82.3721 134.42 82.9326 132.715 82.9326L125.892 82.8486C126.265 84.2126 127.365 85.0254 129.098 85.0254C129.9 85.0254 130.03 84.9133 130.785 84.7264C131.345 84.5396 131.801 84.2966 132.342 84.2966C133.227 84.2966 133.759 84.9133 133.759 85.7167C133.759 86.2305 133.544 86.8471 132.743 87.4637C131.829 88.0242 130.599 88.454 128.921 88.454C125.286 88.454 121.456 86.2772 121.456 81.4006C121.456 76.5239 125.547 74.2163 128.595 74.2163C131.643 74.2163 135.334 76.6546 135.334 80.6812ZM125.883 80.0085H131.13C130.86 78.4764 129.816 77.9159 128.586 77.9159C127.355 77.9159 126.125 78.4764 125.883 80.0085Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.978 76.0661C146.136 76.2529 146.509 76.7107 146.509 77.4113C146.509 78.4577 145.81 78.9902 144.878 78.9902C144.291 78.9902 143.676 78.8033 143.135 78.2148C142.604 77.7009 142.147 77.5702 141.718 77.5702C141.019 77.5702 140.618 77.9158 140.618 78.4016C140.618 78.5324 140.535 79.0182 141.578 79.3359L143.154 79.8217C145.13 80.4102 147.003 81.4285 147.003 83.9229C147.003 87.0339 144.198 88.454 141.411 88.454C138.922 88.454 137.692 87.4076 136.89 86.7349C136.732 86.5761 135.977 85.7167 135.977 84.7264C135.977 84.0537 136.378 83.1475 137.58 83.1475C138.437 83.1475 138.922 83.68 139.295 84.0818C140.152 84.8852 140.796 85.016 141.411 85.016C142.483 85.016 142.771 84.5302 142.771 84.1565C142.771 84.0537 142.799 83.4558 141.597 83.0821L140.339 82.7084C137.561 81.877 136.406 80.4009 136.406 78.4203C136.406 75.5242 139.053 74.2069 141.541 74.2069C143.256 74.2069 145.074 74.8515 145.959 76.0567L145.978 76.0661Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_2739",
    x1: 73.6165,
    y1: 60.7062,
    x2: 73.6165,
    y2: -4.49736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#33B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3BB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#49B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#77C3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#96CA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BCD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E6DB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_2739",
    x1: 73.6165,
    y1: -120.356,
    x2: 73.6165,
    y2: -4.49692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#33B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_301_2739",
    x1: 73.6166,
    y1: 60.7062,
    x2: 73.6166,
    y2: -4.49701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#33B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3BB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#49B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#77C3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#96CA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BCD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E6DB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_301_2739",
    x1: 73.6165,
    y1: 17.316,
    x2: 73.6165,
    y2: 30.6128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F2E12A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CEE756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ADED7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#91F2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7AF6BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66F9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58FBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4DFDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#47FEFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a528b5070c7f5a6f21dbc0d06a66b2da.svg";
export { ForwardRef as ReactComponent };